<div [formGroup]="experimentDesignFormGroup" class="form-horizontal">
  <div class="form-group">
    <label class="control-label col-sm-2">Spray Study?
      <a [tooltip]="tooltipText" placement="right" container="body">
        <span class="glyphicon glyphicon-info-sign"></span>
      </a>
    </label>
    <span class="col-sm-10">
      <ui-switch formControlName="sprayStudy" checkedLabel="Yes" uncheckedLabel="No"
        (change)="getSprayBoothValue($event)">
      </ui-switch>
    </span>

  </div>
</div>
<div *ngIf="isSprayBooth">
  <app-vertical-tab-group [stacked]="false">
    <app-vertical-tab *ngFor="let treatment of treatments.controls; let i = index"
      [title]="'Treatment ' + treatment.value.treatmentNumber" [hasError]="treatment.get('sprayBoothStudy').invalid">
      <div>
        <div>
          <app-spray-booth-study-form class="spray-study-position" [treatment]="treatment"
            [experimentDesignFormGroup]="experimentDesignFormGroup" [isSprayBoothStudy]="isSprayBooth"
            [sprayStudyOptions]="sprayStudyOptions" [activeOptions]="activeOptions" [adjuvantOptions]="adjuvantOptions" #sprayStudyForm>
          </app-spray-booth-study-form>
          <div class="text-right spray-study-all-btn">
            <button class="btn btn-default" type="button" (click)="applyToAllSprayStudies(i)">
              Apply to All
            </button>
          </div>
        </div>
      </div>
    </app-vertical-tab>
  </app-vertical-tab-group>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/spray-booth-study/spray-booth-study.component.html